import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { IntegrationSettings } from '../../../schema'
import { IntegrationMappingFilterSection } from '../IntegrationMappingFilterSection'
import { SetOwnershipSection } from '../ContactMappingSettings/SetOwnershipSection'
import { MapEventFieldsSection } from './MapEventFieldsSection'
import { CalendarContactLinking } from './CalendarContactLinking'

interface CustomCalendarAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
}

export const CustomCalendarAdminSettings: React.FC<CustomCalendarAdminSettingsProps> = ({ serviceId, formKey = 0 }) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const eventObject = watch('mappings.calendar.objectName')

  if (!eventObject) {
    return (
      <Row className='mt-7'>
        <Col>
          <p className='zocks-text-gray-600'>Select a {getIntegrationDisplayName(serviceId)} object to configure how Zocks reads events from it.</p>
        </Col>
      </Row>
    )
  }

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <MapEventFieldsSection serviceId={serviceId} key={formKey} />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <CalendarContactLinking serviceId={serviceId} key={formKey} />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <SetOwnershipSection
            serviceId={serviceId}
            mappingKey='calendar'
            description={`Control which events are returned based on record ownership. By default, Zocks only fetches events owned by the syncing advisor.`}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <IntegrationMappingFilterSection
            key={formKey}
            serviceId={serviceId}
            mappingKey='calendar'
            title='Event Filters'
            description={`Add filters to control which ${getIntegrationDisplayName(serviceId)} ${eventObject} records Zocks queries. Conditions within a filter group are combined with AND; filter groups are combined with OR, so an event is returned if it matches any group.`}
          />
        </Col>
      </Row>
    </>
  )
}
